import capitalize from "./capitalize";
import sortBy from "lodash.orderby";

const treatData = ({ metadata, title }) => {
  if (metadata?.app_image?.[0]) {
    return fetch(
      `/wp-json/wp/v2/media/${metadata.app_image[0]}`
    )
      .then((res) => res.json())
      .then(({ media_details, source_url }) => {
        const imgUrl =
          media_details?.sizes?.medium?.source_url || source_url || "";
        return {
          title: capitalize(title?.rendered),
          priority: Number(metadata?.priority),
          url: metadata?.app_url?.[0],
          type: metadata?.app_frame?.[0],
          subtitle: metadata?.subtitle?.[0],
          logo: imgUrl,
        };
      })
      .catch((err) => {
        console.log(err);
      });
  } else
    return new Promise((resolve) => {
      resolve({
        title: capitalize(title?.rendered),
        priority: Number(metadata?.priority),
        type: metadata?.app_frame?.[0],
        url: metadata?.app_url?.[0],
      });
    });
};

export default async (response) => {
  let links = [];
  for (var post of response) {
    await treatData(post).then((res) => links.push(res));
  }
  return [
    ...sortBy(
      links,
      window.AppInfo.linksSortingParameter === "name"
        ? ["title", "priority"]
        : ["priority", "title"],
      [
        window.AppInfo.linksSortingDirection,
        window.AppInfo.linksSortingDirection,
      ]
    ).map((e) => ({ ...e })),
  ];
};
